import { render, staticRenderFns } from "./TemplateFileCard.vue?vue&type=template&id=5f895378&scoped=true&"
import script from "./TemplateFileCard.vue?vue&type=script&lang=js&"
export * from "./TemplateFileCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFileCard.vue?vue&type=style&index=0&id=5f895378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f895378",
  null
  
)

export default component.exports